module.exports = __webpack_public_path__ + "static/service-604fa8d6f4ab9d1ab3291286499a2cf6.svg";